export default {
  apiServerUrl: 'https://app-funfit.the-dev.org/',
  siteDomain: 'https://app-funfit.the-dev.org/',
  frontSiteDomain: 'https://funfit.the-dev.org/'
};